export const apiAction = payload => ({
    type: 'API',
    payload
});